/** * Created by lobin on 2020/9/10. */
<template>
  <page :footerShow="false">
    <van-notice-bar
      color="#1989fa"
      background="#ecf9ff"
      left-icon="info-o"
      mode="link"
      class="partner-info"
    >
      {{ noticeTitle }}
      <template #right-icon>
        <router-link
          class="recharge-link"
          :to="`/courier/recharge?partner=${partnerId}`"
          >立即充值</router-link
        >
      </template>
    </van-notice-bar>

    <div class="form-wrap">
      <van-form @submit="onSubmit" :show-error-message="false">
        <van-field
          ref="code"
          v-model="formData.code"
          @input="codeChange"
          :border="false"
          :class="{ focused: focused === 'code' }"
          clearable
          @focus="
            () => {
              setfocs('code');
              showKeybord = false;
            }
          "
          @blur="setfocs('')"
          placeholder="单号"
          @click="codeInput"
          @keyup.enter="confirmCode"
          :rules="[{ required: true, message: '请填写单号' }]"
        >
          <template #button>
            <!--            <van-button size="small" type="danger" @click="() => this.cleanCode">清除</van-button>-->
          </template>
        </van-field>
        <van-field
          v-model="formData.phone"
          type="tel"
          ref="phone"
          readonly
          :border="false"
          placeholder="手机号"
          clearable
          :class="{ focused: focused === 'phone' }"
          @focus="setfocs('phone')"
          @blur="setfocs('')"
          @input="getPhoneTips"
          @click="phoneInput"
          :rules="[{ required: true, message: '请填写手机号' }]"
        >
          <template #button>
            <van-button size="small" type="danger" @click="formData.phone = ''"
              >清除</van-button
            >
          </template>
        </van-field>
        <van-radio-group
          v-model="formData.phone"
          class="phone-tips"
          v-if="formData.phone.length < 7"
        >
          <van-cell-group>
            <van-cell
              v-for="item in phonetips"
              :title="item.name ? `${item.phone}(${item.name})` : item.phone"
              clickable
              @click="selectPhone(item)"
              :key="item.phone"
            >
              <template #right-icon>
                <van-radio :name="item.phone" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-field
          readonly
          clickable
          class="excom-shooser"
          :border="false"
          :value="formData.excom"
          @click="showPicker = true"
          :rules="[{ required: true, message: '请选择快递公司' }]"
        >
          <template #input>
            <van-radio-group v-model="formData.excom" direction="horizontal">
              <van-radio
                :class="{ checked: item.pinyin === formData.excom }"
                v-for="item in exComList"
                :key="item.pinyin"
                :name="item.pinyin"
              >
                <div class="excom-shooser-num">
                  <van-image
                    round
                    width="0.48rem"
                    height="0.48rem"
                    :src="item.icon"
                  />
                </div>
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          class="cabinet-shooser"
          :border="false"
          :rules="[{ required: true, message: '请选择格子' }]"
        >
          <template #input>
            <van-radio-group v-model="formData.boxSize" direction="horizontal">
              <van-radio
                :class="{ checked: item.type === formData.boxSize }"
                v-for="item in availableCabinetInfo"
                :key="item.type"
                :name="item.type"
                :disabled="item.num === 0"
              >
                <div class="cabinet-shooser-num">{{ item.num }}</div>
                <span class="cabinet-shooser-text">{{ item.text }}格子</span>
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <div style="margin: 16px;">
          <van-button
            type="primary"
            block
            native-type="submit"
            style="height: 60px;font-size: 24px;"
            :loading="submitting"
            :disabled="submitting"
          >
            投递
          </van-button>
        </div>
      </van-form>
      <div class="keybord" v-if="showKeybord">
        <div class="keybord-row">
          <div class="keybord-item" @click="clickItem(1)">1</div>
          <div class="keybord-item" @click="clickItem(2)">2</div>
          <div class="keybord-item" @click="clickItem(3)">3</div>
        </div>
        <div class="keybord-row">
          <div class="keybord-item" @click="clickItem(4)">4</div>
          <div class="keybord-item" @click="clickItem(5)">5</div>
          <div class="keybord-item" @click="clickItem(6)">6</div>
        </div>
        <div class="keybord-row">
          <div class="keybord-item" @click="clickItem(7)">7</div>
          <div class="keybord-item" @click="clickItem(8)">8</div>
          <div class="keybord-item" @click="clickItem(9)">9</div>
        </div>
        <div class="keybord-row">
          <div class="keybord-item" @click="clickItem(0)">0</div>
          <div
            class="keybord-item"
            style="flex: 2.21"
            @click="clickItem('del')"
          >
            <svg
              viewBox="0 0 32 22"
              xmlns="http://www.w3.org/2000/svg"
              class="van-key__delete-icon"
            >
              <path
                d="M28.016 0A3.991 3.991 0 0132 3.987v14.026c0 2.2-1.787 3.987-3.98 3.987H10.382c-.509 0-.996-.206-1.374-.585L.89 13.09C.33 12.62 0 11.84 0 11.006c0-.86.325-1.62.887-2.08L9.01.585A1.936 1.936 0 0110.383 0zm0 1.947H10.368L2.24 10.28c-.224.226-.312.432-.312.73 0 .287.094.51.312.729l8.128 8.333h17.648a2.041 2.041 0 002.037-2.04V3.987c0-1.127-.915-2.04-2.037-2.04zM23.028 6a.96.96 0 01.678.292.95.95 0 01-.003 1.377l-3.342 3.348 3.326 3.333c.189.188.292.43.292.679 0 .248-.103.49-.292.679a.96.96 0 01-.678.292.959.959 0 01-.677-.292L18.99 12.36l-3.343 3.345a.96.96 0 01-.677.292.96.96 0 01-.678-.292.962.962 0 01-.292-.68c0-.248.104-.49.292-.679l3.342-3.348-3.342-3.348A.963.963 0 0114 6.971c0-.248.104-.49.292-.679A.96.96 0 0114.97 6a.96.96 0 01.677.292l3.358 3.348 3.345-3.348A.96.96 0 0123.028 6z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import {
  partnerInfo,
  getExComList,
  mailNoInfo,
  phoneTips,
  availableCabinet,
  inbound
} from "@/apis/index";
import { Toast } from "vant";
export default {
  data() {
    return {
      partner: {},
      partnerId: "",
      focused: "code",
      submitting: false,
      phonetips: [],
      showKeybord: false,
      formData: {
        code: "",
        phone: "",
        excom: "",
        partner: "",
        boxSize: "small"
      },
      timer: null,
      showPicker: false,
      exComList: [],
      availableCabinetInfo: {}
    };
  },
  created() {
    const id = this.$route.query.partner;
    this.partnerId = id;
    if (id) {
      this.getPartnerInfo();
      this.getExComList();
      this.getAvailableCabinet();
    }
    this.hideKeybord();
  },
  mounted() {
    this.codeInput();
  },
  computed: {
    noticeTitle() {
      return `${this.partner.name}您账户余额${this.partner.account}元`;
    },
    exComNameList() {
      return this.exComList.map(({ name }) => name);
    }
  },
  methods: {
    async getPartnerInfo() {
      const data = await partnerInfo(this.partnerId);
      this.formData.excom = data.pinyin;
      this.partner = data;
    },

    async getExComList() {
      const [err, res] = await this.awaitTo(getExComList());
      if (!err) {
        this.exComList = res;
      }
    },
    async getPhoneTips() {
      const phone = this.formData.phone;
      console.log(phone);
      if (phone.length > 3) {
        const [err, res] = await this.awaitTo(phoneTips(phone));
        if (!err) {
          this.phonetips = res;
        }
      }
    },
    selectPhone(item) {
      this.formData.phone = item.phone;
    },
    cleanPhone() {
      this.formData.phone = "";
      this.phonetips = [];
    },
    cleanCode() {
      console.log("clean code");
      this.formData.code = "";
    },
    async getAvailableCabinet() {
      const [err, res] = await this.awaitTo(availableCabinet());
      if (!err) {
        this.availableCabinetInfo = res;
      }
    },
    setfocs(name) {
      this.focused = name;
    },
    confirmCode() {
      console.log("confirm");
      this.getMailInfo();
      this.$refs.phone.focus();
      this.focused = "phone";
      this.showKeybord = true;
    },
    codeChange(e) {
      this.formData.code = e;
    },
    async getMailInfo() {
      const code = this.formData.code;
      const [err, res] = await this.awaitTo(mailNoInfo(code));
      if (!err) {
        console.log(res);
        if (res.length === 1) {
          this.formData.phone = res[0].phone;
        } else {
          this.phonetips = res;
        }
      }
    },
    async onSubmit() {
      const submitData = { ...this.formData, partner: this.partnerId };
      this.submitting = true;
      const laoding = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "开箱中..."
      });
      const [err, res] = await this.awaitTo(inbound(submitData));
      laoding.clear();
      if (!err) {
        if (res.success) {
          this.$toast.success("入站成功");
          this.handlePickSuccess(res.serial);
        } else {
          this.handlePickFail(res.msg);
        }
      } else {
        this.$toast.fail(err.message);
      }
      this.submitting = false;
    },
    // 取件成功
    handlePickSuccess(serial) {
      this.$dialog
        .alert({
          title: "入站成功",
          message: `格子编号:${serial}`,
          theme: "round-button"
        })
        .then(() => {
          this.formData.code = "";
          this.formData.phone = "";
          this.codeInput();
        });
    },
    // 取件失败
    handlePickFail(message) {
      this.$dialog
        .confirm({
          title: "入站失败",
          message,
          theme: "round-button",
          confirmButtonText: "重试"
        })
        .then(() => {
          this.onSubmit();
        })
        .catch(() => {});
    },
    clickItem(e) {
      this.focused = "phone";
      const arr = ["del"];
      const val = this.formData.phone;
      if (!arr.includes(e)) {
        this.formData.phone = val + e;
        this.getPhoneTips();
      } else if (e === "del") {
        this.formData.phone = val.slice(0, val.length - 1);
      }
    },
    phoneInput() {
      this.$refs.phone.focus();
      this.focused = "phone";
      this.showKeybord = true;
    },
    codeInput() {
      this.$refs.code.focus();
      this.focused = "code";
      this.showKeybord = false;
    },
    hideKeybord() {
      this.$on("hook:beforeDestroy", () => clearInterval(this.timer));
      this.timer = setInterval(function() {
        if (window.plus) {
          window.plus.key.hideSoftKeybord();
        }
      }, 60);
    }
  }
};
</script>

<style lang="scss">
.partner-info {
  height: rem(50);
  margin: rem(20) rem(30);
  .van-notice-bar__content,
  .van-icon {
    font-size: rem(20);
  }
  .recharge-link {
    color: #1db475;
    font-size: rem(24);
  }
}
.van-notice-bar__wrap {
  line-height: 2.5;
}
.form-wrap {
  width: 45%;
  margin: 0 30% 0 25%;
  .focused {
    .van-cell__value {
      border-color: #359efb;
    }
  }
  .van-field__label {
    font-size: rem(22);
    line-height: rem(60);
  }
  .van-cell__value {
    font-size: rem(22);
    height: rem(48);
    line-height: rem(28);
    padding: rem(8) rem(12);
    border: 1px solid #e1e3e6;
    border-radius: 2px;
  }
  .keybord {
    position: absolute;
    padding: 0;
    width: 26%;
    top: rem(200);
    height: rem(300);
    right: rem(24);
    &-row {
      display: flex;
    }

    &-item {
      height: rem(56);
      line-height: rem(56);
      margin: rem(8);
      font-size: rem(26);
      flex: 1;
      text-align: center;
      align-items: center;
      border-radius: 5px;
      background: #edf0f2;

      &:active {
        background: #6acaa2;
        color: #fff;
      }

      &.confirm {
        height: rem(132);
        line-height: rem(132);
      }
    }
  }
}
.cabinet-shooser {
  height: rem(100);
  padding-left: 0;
  padding-right: 0;
  .van-radio__icon {
    display: none;
  }
  .checked {
    .cabinet-shooser-num {
      background-color: #359efb;
      color: #fff;
    }
  }
  .van-cell__value {
    border: none;
  }
  .van-radio--horizontal {
    margin-right: rem(30);
  }
  &-num {
    width: rem(40);
    height: rem(40);
    background-color: #d5effe;
    border: #dfecf5;
    color: #5ba0e1;
    font-weight: bold;
    border-radius: rem(20);
    text-align: center;
    line-height: rem(40);
    margin-left: rem(8);
    margin-bottom: rem(8);
  }
  &-text {
    font-size: rem(18);
    text-align: center;
  }
}
.excom-shooser {
  position: absolute;
  overflow-y: scroll;
  padding: 0;
  width: 22%;
  top: rem(200);
  height: rem(340);
  left: rem(10);
  .van-radio-group {
    margin-right: -15px;
  }
  .van-radio {
    position: relative;
    opacity: 0.7;
    margin-bottom: rem(10);
    &.checked {
      opacity: 1;
    }
  }
  .van-cell__value {
    border: none;
    height: auto;
  }
  .van-radio__icon {
    position: absolute;
    top: rem(2);
    right: rem(2);
    z-index: 10;
  }
}
.phone-tips {
  padding: 0 16px;
  .van-cell__title {
    font-size: rem(24);
  }
}
</style>
